module.exports = __webpack_public_path__ + "static/media/whitecircle.a309c1f8.svg";